import React, { Component } from 'react';
import moment from 'moment';
import { connect } from 'react-redux';
import LOOKUP from 'constants/lookup';
import { checkDateRange } from 'utils/helpers';
import { reportEmployeeHoursCrumb } from 'utils/breadcrumbInfo';
import { showError } from 'actions/CommonActions';
import { getEmployeeHours, getCsvReport } from 'actions/ReportsAction';
import { getEmployees } from 'actions/EntityActions';
import { formInput, clearFormInput } from 'actions/FormActions';
// Basic Components
import KnowledgeBase from 'screens/components/basic/KnowledgeBaseIcon';
import PageHeader from 'screens/components/basic/PageHeader';
import Grid from 'screens/components/basic/Grid';
import CardSimple from 'screens/components/basic/CardSimple';
import Pagination from 'screens/components/basic/Pagination';
import Body from './Body';
import Header from './Header';
import DateCurrentDisplay from 'screens/containers/report/DateCurrentDisplay';

class EmployeeTotalHours extends Component {

    constructor(props) {

        super(props);

        this.state = {
            activePage: 1,
            itemsPerPage: 200,
            totalRow: 0,
            status: 'None',
            orderBy: 'DESC',
            sortBy: 'Id',
            firstName: "",
            lastName: "",
            id: 0,
            role: "",
            showBody: false,
            model: {
                beginDate: 0,
                endDate: 0,
                branch: 0,
                category: '',
                employeeName: ''
            }
        }

        this.showBody = this.showBody.bind(this);
        this.filter = this.filter.bind(this);
    }

    componentWillMount() {
        const date = new Date()
        this.props.formInput(new Date(date.getFullYear(), date.getMonth(), 1),
            `EmployeeHoursBeginDate`)
        this.props.formInput(date, `EmployeeHoursEndDate`)
        this.props.getEmployees({
            page: this.state.activePage,
            itemsPerPage: this.state.itemsPerPage,
            firstName: this.state.firstName,
            lastName: this.state.lastName,
            id: this.state.id,
            role: this.state.role,
            status: this.state.status,
            orderBy: this.state.orderBy,
            sortBy: this.state.sortBy
        });
    }

    getEmployeeOptions = () => {
        return (this.props.employees || []).map(item => {
            return {
                text: `${item.firstName} ${item.lastName}`,
                value: item.id.toString(),
                branch: item.branches
            };
        });
    }

    getReport = () => {
        let startDate = this.props.beginDate ? moment(this.props.beginDate).format('MM-DD-YYYY') : moment().add('day').format('MM-DD-YYYY');
        let endDate = this.props.endDate ? moment(this.props.endDate).add(1, 'day').format('MM-DD-YYYY') : moment().add('day').format('MM-DD-YYYY');
        let branchId = parseInt(this.props.branch || this.props.loggedBranch, 10);
        let status = parseInt(this.props.status, 10) || 0;
        let pageNumber = this.state.activePage;
        let pageSize = this.state.itemsPerPage;
        let employeeIds = (this.props.employeeFilter || 0).toString();

        this.props.getEmployeeHours({ startDate, endDate, branchId, status, employeeIds, pageNumber, pageSize });
    }

    downloadReport = () => {
        let startDate = this.props.beginDate ? moment(this.props.beginDate).format('MM-DD-YYYY') : moment().add('day').format('MM-DD-YYYY');
        let endDate = this.props.endDate ? moment(this.props.endDate).add(1, 'day').format('MM-DD-YYYY') : moment().add('day').format('MM-DD-YYYY');
        let branchId = parseInt(this.props.branch || this.props.loggedBranch, 10);
        let status = parseInt(this.props.status, 10) || 0;
        let pageNumber = this.state.activePage;
        let pageSize = this.state.itemsPerPage;
        let employeeIds = (this.props.employeeFilter || 0).toString();

        if (checkDateRange(startDate, endDate)) {
            this.props.showError(LOOKUP.report.common.dateRangeError);
        } else {
            this.props.getCsvReport(`reports/excel/shiftbyemployeesummaries?employeeIds=${employeeIds}&branchId=${branchId}&status=${status}&startDate=${startDate}&endDate=${endDate}&pageNumber=${pageNumber}&pageSize=${pageSize}`, "EmployeeTotalHours");
        }
    }

    filter = () => {
        this.setState(pState => {
            return {
                ...pState,
                activePage: 1
            };
        }, this.getReport);
    }

    showBody() {
        if (checkDateRange(this.props.beginDate, this.props.endDate)) {
            this.props.showError(LOOKUP.report.common.dateRangeError);
        } else {
            this.filter();
            setTimeout(this.setState({ showBody: true }), 1000);
        }
    }

    render() {
        const totalRow = (this.props.employeeTotalHours && this.props.employeeTotalHours.length > 0) ? this.props.employeeTotalHours.length : 0;
        return (
            <Grid headerContent={reportEmployeeHoursCrumb}>
                <PageHeader title={LOOKUP.report.employeeHours.text}
                    icon={<KnowledgeBase link="https://knowledge.techpos.ca/en/knowledge/employee" />}
                    description={LOOKUP.report.employeeHours.description}
                />
                <Header
                    employeeOptions={this.getEmployeeOptions()}
                    filter={this.filter}
                    showBody={this.showBody}
                    isBranch={this.props.branch}
                    download={this.downloadReport}
                    loggedBranch={this.props.loggedBranch}
                />
                {this.state.showBody && <DateCurrentDisplay />}
                {
                    this.state.showBody && this.props.employeeTotalHours &&
                    <CardSimple>
                        <Body employees={this.props.employeeTotalHours}
                            beginDate={this.props.beginDate}
                            endDate={this.props.endDate}
                        />
                        <Pagination
                            length={totalRow}
                            itemsPerPage={this.state.itemsPerPage}
                            activePage={this.state.activePage}
                            onPageChange={this.changePage}
                        />
                    </CardSimple>
                }
            </Grid>
        );
    }

}

const mapStateToProps = state => {
    return {
        employeeTotalHours: state.reports.employeeTotalHours,
        loggedBranch: state.common.branchId,
        employees: state.entity.employeeList,
        branch: state.form.EmployeeHoursBranchOption,
        beginDate: state.form.EmployeeHoursBeginDate,
        endDate: state.form.EmployeeHoursEndDate,
        employeeFilter: state.form.EmployeeHoursEmployeeName
    };
};

const mapDispatchToProps = dispatch => {
    return {
        getEmployeeHours: model => dispatch(getEmployeeHours(model)),
        getEmployees: (model) => dispatch(getEmployees(model)),
        clearFormInput: (name) => dispatch(clearFormInput(name)),
        showError: (message) => dispatch(showError(message)),
        formInput: (value, name) => dispatch(formInput(value, name)),
        getCsvReport: (url, name) => dispatch(getCsvReport(url, name))
    };
};


export default connect(mapStateToProps, mapDispatchToProps)(EmployeeTotalHours);